module.exports = __webpack_public_path__ + "static/media/gift.8d7d2626.png";